import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, Phone, Mail } from "lucide-react";
import { brand } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-ink text-cream pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/kxq2bn2y_The%20Sterling%20Touch%20Logo%20%289%29.png"
                alt="The Sterling Touch"
                className="w-24 h-24 object-contain"
              />
              <div>
                <div className="font-brand text-lg md:text-xl">
                  {brand.name}
                </div>
                <div className="text-xs italic text-sterling mt-1">
                  {brand.tagline}
                </div>
              </div>
            </div>
            <p className="mt-5 text-cream/70 max-w-md leading-relaxed">
              Designed for homes that deserve more than a standard clean.
              Refined, discreet, meticulous — a quiet luxury for your
              everyday.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={`tel:${brand.phone.replace(/\s/g, "")}`}
                className="flex items-center gap-2 text-sm text-cream/80 hover:text-sterling transition-colors"
              >
                <Phone size={14} /> {brand.phone}
              </a>
              <span className="w-px h-4 bg-cream/20" />
              <a
                href={`mailto:${brand.email}`}
                className="flex items-center gap-2 text-sm text-cream/80 hover:text-sterling transition-colors"
              >
                <Mail size={14} /> {brand.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-sterling">
              Explore
            </div>
            <ul className="mt-5 space-y-3 text-cream/80">
              <li>
                <Link
                  to="/cleaning"
                  className="hover:text-sterling transition-colors"
                >
                  Service Areas
                </Link>
              </li>
              {[
                ["Services", "#services"],
                ["About", "#about"],
                ["Why Us", "#why-us"],
                ["FAQ", "#faq"],
                ["Contact", "#contact"],
              ].map(([l, h]) => (
                <li key={l}>
                  <a
                    href={h}
                    className="hover:text-sterling transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-sterling">
              Working Hours
            </div>
            <ul className="mt-5 space-y-2 text-cream/80 text-sm">
              <li>{brand.hours.weekday}</li>
              <li>{brand.hours.saturday}</li>
              <li>{brand.hours.sunday}</li>
            </ul>
            <a
              href="#quote-form"
              className="inline-flex items-center gap-2 mt-6 px-5 h-11 rounded-full bg-sterling text-ink hover:bg-[#c89c89] transition-colors text-sm"
            >
              Request a personalised quote
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-xs text-cream/50">
            © 2026 {brand.name}. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-cream/50">
            <Link
              to="/terms-and-conditions"
              className="hover:text-sterling transition-colors"
              data-testid="footer-terms-link"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              to="/privacy-policy"
              className="hover:text-sterling transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <a
              href="#home"
              className="flex items-center gap-1 hover:text-sterling transition-colors"
            >
              Back to top <ArrowUp size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
